<form *ngIf="!filtersLoading; else showLoading" [formGroup]="filters.filtersFormGroup">
	<div class="row">
		<ng-select class="col" appearance="outline" appendTo="body" formControlName="status" placeholder="Status">
			<ng-option *ngFor="let item of statuses" [value]="item.id">{{ item.name }}</ng-option>
		</ng-select>
		<ng-select
			class="col"
			appearance="outline"
			appendTo="body"
			formControlName="kinds"
			[searchable]="false"
			multiple="true"
			placeholder="Rodzaj"
		>
			<ng-option *ngFor="let item of kinds" [value]="item.id">{{ item.name }}</ng-option>
		</ng-select>
		<ng-select
			class="col"
			appearance="outline"
			appendTo="body"
			formControlName="users__id__in"
			multiple="true"
			placeholder="Przypisano"
			[minTermLength]="minLengthFullName"
			[loading]="usersLoading"
			loadingText="Wczytywanie..."
			typeToSearchText="Wprowadź {{ minLengthFullName }} lub więcej znaków"
			[typeahead]="usersInput$"
		>
			<ng-option *ngFor="let item of users$ | async" [value]="item.id"
				>{{ item.firstName }} {{ item.lastName }}</ng-option
			>
		</ng-select>

		<mat-form-field class="col">
			<mat-label>Termin</mat-label>
			<mat-date-range-input [rangePicker]="picker">
				<input matStartDate (focus)="picker.open()" readonly formControlName="deadline__gte" placeholder="Od" />
				<input matEndDate (focus)="picker.open()" readonly formControlName="deadline__lte" placeholder="Do" />
			</mat-date-range-input>
			<mat-hint>DD.MM.YYYY – DD.MM.YYYY</mat-hint>
			<mat-datepicker-toggle
				*ngIf="
					filters.filtersFormGroup.get('deadline__gte').value &&
					filters.filtersFormGroup.get('deadline__lte').value
				"
				matSuffix
			>
				<i matDatepickerToggleIcon (click)="clearDateRange()" class="fas fa-times"></i>
			</mat-datepicker-toggle>
			<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-date-range-picker #picker></mat-date-range-picker>
		</mat-form-field>
	</div>
	<div class="row row-cols-6 justify-content-end">
		<button class="col-1" mat-raised-button (click)="filters.clearFilters()">Wyczyść</button>
		<button
			mat-raised-button
			class="col-1 ms-2"
			color="primary"
			[disabled]="buttonLoading"
			(click)="setFilters()"
			type="submit"
		>
			<mat-icon *ngIf="buttonLoading; else buttonSpinner"><mat-spinner diameter="20"></mat-spinner></mat-icon>
			<ng-template #buttonSpinner>Pokaż</ng-template>
		</button>
	</div>
</form>
<ng-template #showLoading><mat-progress-bar mode="indeterminate"></mat-progress-bar></ng-template>
